module.exports = __webpack_public_path__ + "static/media/pic_01.e8bc6cce.png";